<template>
  <DataTable
    :title="title"
    :createable="!!userStore.hasPermission('login-policy:write')"
    :cols-map="{
      [translate('Version')]: '#version',
      [translate('Based on')]: '#basedOnVersion',
      [translate('Last Changed')]: 'updated',
      Status: '#status',
    }"
    :rows="rows"
    style="border-width: 1px"
    :loading="loading"
    @create="$emit('createNew')"
  >
    <template #toolbar-actions></template>

    <template #customCell="{row, col}">
      <td v-if="col === '#version'">{{ translate('Version') }} {{ row.version }}</td>
      <td v-if="col === '#basedOnVersion'">
        {{ row.basedOnVersion ? `${translate('Version')} ${row.basedOnVersion}` : '-' }}
      </td>
      <td v-if="col === '#status'">
        <LoginPolicyStatusBadge :login-policy="loginPolicies[row.index]" />
      </td>
    </template>

    <template #actions="{row}">
      <div class="align-middle d-inline-flex flex-shrink-0">
        <LoginPolicyDropdown
          :login-policy="loginPolicies[row.index]"
          @activate="$emit('activate', loginPolicies[row.index].id)"
          @edit="$emit('edit', loginPolicies[row.index].id)"
          @edit-as-new="$emit('editAsNew', loginPolicies[row.index].id)"
          @view="$emit('view', loginPolicies[row.index].id)"
          @delete="$emit('delete', loginPolicies[row.index].id)"
          @deactivate="$emit('deactivate', loginPolicies[row.index].id)"
        />
      </div>
    </template>
  </DataTable>
</template>
<script setup lang="ts">
import {LoginPolicy} from '@/api/apolloPlatform/loginPolicy';

const {displayTimeStamp, translate} = useLocalisation();

const props = defineProps<{
  title: string;
  loginPolicies: LoginPolicy[];
  loading: boolean;
}>();

defineEmits<{
  createNew: [];
  activate: [id: string];
  edit: [id: string];
  editAsNew: [id: string];
  view: [id: string];
  delete: [id: string];
  deactivate: [id: string];
}>();

const rows = computed(() =>
  props.loginPolicies.map((lp, index) => ({
    ...lp,
    index: index,
    updated: displayTimeStamp(lp.updated),
  })),
);

const userStore = useUserStore();
</script>
